import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { trackEvent } from "@/lib/posthog";

export default function CheckoutSuccess() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { refreshSubscription } = useAuth();
  const handled = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (handled.current) return;
    if (searchParams.get("checkout") !== "success") return;
    handled.current = true;

    searchParams.delete("checkout");
    setSearchParams(searchParams, { replace: true });

    toast.success("Paiement réussi ! Activation de votre plan...");
    trackEvent("checkout_success");
    let attempts = 0;
    const tryRefresh = async () => {
      await refreshSubscription({ force: true });
      attempts++;
      if (attempts < 5) {
        timerRef.current = setTimeout(tryRefresh, 2000);
      }
    };
    tryRefresh();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [searchParams, setSearchParams, refreshSubscription]);

  return null;
}
